import React from "react";
import { Row } from "antd";
import { StepFormProps } from "../../types/types";
import cashOutline from "../../assets/images/cash-outline.svg";
import vectorOutline from "../../assets/images/vector-outline.svg";
import calendarOutline from "../../assets/images/calendar-outline.svg";
import calendarClearOutline from "../../assets/images/calendar-clear-outline.svg";
import linkOutline from "../../assets/images/link-outline.svg";
import { ApprovedCard } from "../contents/approved-card";

export const Approved: React.FC<StepFormProps> = ( props ) => {
  const extras = {
    "Interest rate": {
      "Interest rate": "1.234%*",
      "Base rate": "1.234%*",
      "Default interest": "€1,234.56",
      "Interest payment date": "Aug 29",
    },
    Term: {
      "Facility end date": "May 29",
      "Final repayment date": "Jun 29",
    },
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <ApprovedCard
          title={"Facility limit"}
          tooltip={""}
          icon={cashOutline}
          details={"€123,456*"}
        ></ApprovedCard>

        <ApprovedCard
          title={"Interest rate"}
          tooltip={""}
          icon={vectorOutline}
          details={"1.234%*"}
          extras={extras["Interest rate"]}
        ></ApprovedCard>

        <ApprovedCard
          title={"Term"}
          tooltip={""}
          icon={calendarOutline}
          details={"12 months"}
          extras={extras["Term"]}
        ></ApprovedCard>

        <ApprovedCard
          title={"Expected drawdown date"}
          tooltip={""}
          icon={calendarClearOutline}
          details={"July 29"}
        ></ApprovedCard>

        <ApprovedCard
          title={"Documents & Connections"}
          tooltip={""}
          icon={linkOutline}
          button={"Manage"}
          details={""}
        ></ApprovedCard>
      </Row>
    </>
  );
};
